import { RebalanceLoadingContainer as RebalanceLoading } from './container';

export default RebalanceLoading;
